<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_app_no']">
              <a-input :placeholder="language['common.pleaseInput']+language['gift_app_no']" v-model="queryParam.code" :disabled='appLimit.flag'></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_user_app']">
              <a-select  :placeholder="language['common.pleaseInput']+language['gift_user_app']" @change='changeAppCode' v-model='name' :disabled='appLimit.flag' >
                <a-select-option v-for="(value, key) in appOptions" :key="key" :value="key">
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['platform.roleUser.columns2.status']">
              <j-dict-select-tag v-model="queryParam.status" :title="language['cst.signAuditStatus']" dictCode="gift_app_status" :placeholder="language['common.pleaseInput']+language['platform.roleUser.columns2.status']"/>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_app_pre_time']">
              <a-range-picker  :placeholder="language['common.pleaseInput']+language['gift_app_pre_time']" style="display: flex"  v-model='forecastDate'  @change='pickForecastDate' />
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_app_start_time']">
              <a-range-picker :placeholder="language['common.pleaseInput']+language['gift_app_start_time']" style="display: flex" v-model='startDate' @change='pickStartDate' />
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'gift:app:add'" >{{language['common.insertButton']}}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('app')" v-has="'gift:app:export'" >{{language['common.exportButton']}}</a-button>
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
<!--      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="false"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>


        <span slot="switchSlot" slot-scope="active, record, idx">
             <a-switch :checked='active'  @click='changeActive(active,record, idx)' :disabled=' record.status === 0'/>
        </span>

        <template slot='content'  slot-scope='text'>
          <div class='slot-content' :title='text'>
            <a-span >{{text}}</a-span>
          </div>
        </template>

        <template slot='app' slot-scope='text'>
          <div class='slot-content' :title='appOptions[text]' >
            <a-span >{{appOptions[text]}}</a-span>
          </div>
        </template>


        <span slot="action" slot-scope="status, record">
            <div  v-if="status == '1'">
                <a @click="handleEdit(record)" v-has="'gift:app:edit'">{{language['common.edit']}}</a>
            </div >
            <div  v-else>
                <a @click="handleEdit(record)" v-has="'gift:app:edit'" >{{language['common.edit']}}</a>
                <a-divider type="vertical" v-has="'gift:app:edit'" />
                <a-popconfirm :title="language['gift_app_state_comfirm']" @confirm="() => handleCheck(record)"  v-has="'gift:app:check'" >
                      <a>{{language['gift_app_sign']}}</a>
                </a-popconfirm>
                <a-divider type="vertical" v-has="'gift:app:check'" />
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.code)" v-has="'gift:app:delete'" >
                      <a>{{language['common.delete']}}</a>
                </a-popconfirm>
            </div >

<!--
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" v-show='record.status !==1' />
            <a-popconfirm title="确定核准吗?" @confirm="() => handleCheck(record)"  v-show='record.status !==1'>
                  <a>核准</a>
            </a-popconfirm>
            <a-divider type="vertical"  v-show='record.status !==1'/>
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.code)"  v-show='record.status !==1'>
                  <a>删除</a>
            </a-popconfirm>
          -->
        </span>

      </a-table>
    </div>

    <app-modal ref="modalForm" @ok="modalFormOk"/>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AppModal from './modules/AppModal'
  import '@/assets/less/TableExpand.less'
  import { getAction, postAction } from '@/api/manage'
  import dayjs, { Dayjs } from 'dayjs';

  export default {
    name: "AppList",
    mixins:[JeecgListMixin],
    components: {
      AppModal
    },
    data () {
      const language = this.$store.getters.language;
      return {
        disableMixinCreated: true,
        name:'',
        description: 'app管理页面',
        forecastDate:'',
        startDate: '',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:language['gift_app_no'],
            align:"center",
            dataIndex: 'code'
          },
          {
            title:language['ipsys.eventName'],
            align:"center",
            dataIndex: 'name',
            width: 200,
            scopedSlots: { customRender: 'content' },
          },
          {
            title:language['platform.roleUser.columns2.status'],
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title:language['gift_app_pre_time'],
            align:"center",
            dataIndex: 'forecastAt',
          },
          {
            title:language['gift_app_start_time'],
            align:"center",
            dataIndex: 'startAt',
          },
          {
            title: language['gift_app_end_time'],
            align:"center",
            dataIndex: 'endAt',
          },
          {
            title:language['gift_app_up_down'],
            align:"center",
            dataIndex: 'active',
            scopedSlots: { customRender: 'switchSlot' },
          },
          {
            title: language['common.action'],
            dataIndex: 'status',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/carnival/app/list",
          delete: "/carnival/app/delete",
          deleteBatch: "/carnival/app/deleteBatch",
          exportXlsUrl: "/carnival/app/exportXls",
          importExcelUrl: "carnival/app/importExcel",
          turnActiveStatus: "carnival/app/turnActiveStatus",
          checkApp: "/carnival/app/check",
          getInitData: "/carnival/app/initData",
          checkAppLimit: '/carnival/app/checkAppLimit/code',
        },
        dictOptions:{},
        superFieldList:[],
        appOptions:[],
        appLimit:{
          flag: false,
          value: undefined
        }
      }
    },
    created() {
      this.getInitData();
      this.checkAppLimit();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      searchReset(){
        if (this.appLimit.flag){
          this.name = this.appLimit.value;
          this.queryParam.code = this.appLimit.value;
        }else {
          this.queryParam = {  };
          this.forecastDate = undefined;
          this.startDate = undefined;
          this.name = undefined;
        }
        this.loadData(1);
      },
      async checkAppLimit(){
        await getAction(this.url.checkAppLimit).then(res=>{
          if (res.success){
            this.appLimit.flag = true;
            this.appLimit.value = res.result;
            this.name = res.result;
            this.queryParam.code = this.appLimit.value;
          }
        })
        this.loadData(1);
      },
      changeAppCode(value, option){
        this.queryParam.code = option.key;
      },
      getInitData(){
        getAction(this.url.getInitData).then(res=>{
          if (res.success){
            this.appOptions = res.result.app;
            this.$forceUpdate();
          }
        })
      },
      pickForecastDate(value, dateString) {
        this.queryParam.forecastAtBegin = dateString[0]
        this.queryParam.forecastAtEnd = dateString[1]
      },

      pickStartDate(value, dateString) {
        this.queryParam.startAtBegin = dateString[0]
        this.queryParam.startAtEnd = dateString[1]
      },


      changeActive(checked,record, idx){
        console.log("data",this.dataSource);
        console.log("checked",checked);
         if ( checked === 0 && record.status != '1'){
           this.$message.error("审核未通过，不可上架！");
           return false;
         }
         postAction(this.url.turnActiveStatus,record).then((res)=>{
           console.log(this.url.turnActiveStatus)
            if (res.success){
              // this.loadData();
             // if (this.dataSource[idx]) this.dataSource[idx].active = checked === 0 ? 1 : 0;
              this.loadData();
              return true;
            }else {
              this.$message.error(res.message);
              return false;
            }
         })
      },
      handleCheck(record){
          if (record.status === 1){
            this.$message.error("审核已通过，不可重复核准！");
            return false;
          }
          postAction(this.url.checkApp,record).then((res)=>{
            if (res.success){
              this.loadData(1);
              return true;
            }else {
              this.$message.error(res.message);
              return false;
            }
          })
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  .slot-content{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 200px;
  }

</style>